<template>
  <div
    class="inputMultiple"
    :class="[selectSize ? 'inputMultiple--' + selectSize : '']"
  >
    <div
      class="inputMultiple__tags"
      v-if="multiple"
      ref="tags"
      :style="{ width: '90%' }"
    >
      <span v-if="collapseTags && inputed.length">
        <el-tag
          :closable="false"
          :size="collapseTagSize"
          :hit="true"
          type="info"
          @close="deleteTag($event, inputed[0])"
          disable-transitions
        >
          <span class="inputMultiple__tags-text" @click="visible = true">{{
            tagdata[0]
          }}</span>
        </el-tag>
        <el-tag
          v-if="inputed.length > 1"
          :closable="false"
          :size="collapseTagSize"
          type="info"
          disable-transitions
        >
          <span class="inputMultiple__tags-text" @click="visible = true"
            >+ {{ inputed.length - 1 }}</span
          >
        </el-tag>
      </span>
      <transition-group
        class="tag-group"
        @after-leave="resetInputHeight"
        v-if="!collapseTags"
      >
        <el-tag
          v-for="item in inputed"
          :key="getValueKey(item)"
          :closable="false"
          :size="collapseTagSize"
          :hit="item.hitState"
          type="info"
          @close="deleteTag($event, item)"
          disable-transitions
        >
          <span class="inputMultiple__tags-text" @click="visible = true">{{
            item.xm
          }}</span>
        </el-tag>
      </transition-group>

      <input
        type="text"
        class="inputMultiple__input"
        :class="[selectSize ? `is-${selectSize}` : '']"
        :disabled="selectDisabled"
        :autocomplete="autoComplete || autocomplete"
        :size="selectSize"
        @focus="handleFocus"
        @blur="softFocus = false"
        v-model="query"
        v-if="filterable"
        :readonly="readonly"
        :style="{
          'flex-grow': '1',
          width: inputLength / (inputWidth - 32) + '%',
          'max-width': inputWidth - 42 + 'px',
        }"
        ref="input"
      />
    </div>
    <el-input
      ref="reference"
      v-model="selectedLabel"
      type="text"
      :placeholder="currentPlaceholder"
      :name="name"
      :id="id"
      :autocomplete="autoComplete || autocomplete"
      :size="selectSize"
      :disabled="selectDisabled"
      :readonly="readonly"
      :validate-event="false"
      :class="{ 'is-focus': visible }"
      @focus="handleFocus"
      @blur="handleBlur"
    >
      <template slot="prefix" v-if="$slots.prefix">
        <slot name="prefix"></slot>
      </template>
      <template slot="suffix">
        <i
          v-if="showClose"
          class="inputMultiple__caret el-input__icon el-icon-circle-close"
          @click="handleClearClick"
        ></i>
      </template>
    </el-input>
  </div>
</template>

<script type="text/babel">
export default {
  name: "InputMultiple",
  componentName: "InputMultiple",
  computed: {
    selectSize() {
      return this.size;
    },
    selectDisabled() {
      return this.disabled || (this.elForm || {}).disabled;
    },
    collapseTagSize() {
      return ["small", "mini"].indexOf(this.selectSize) > -1 ? "mini" : "small";
    },
    propPlaceholder() {
      return typeof this.placeholder !== "undefined"
        ? this.placeholder
        : this.t("el.select.placeholder");
    },
    showClose() {
      let hasValue = this.multiple
        ? Array.isArray(this.value) && this.value.length > 0
        : this.value !== undefined && this.value !== null && this.value !== "";
      let criteria = this.clearable && !this.selectDisabled && hasValue;
      return criteria;
    },
  },
  components: {},
  props: {
    name: String,
    id: String,
    value: {
      required: true,
    },
    label: {
      type: String,
      default: "value",
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    /** @Deprecated in next major version */
    autoComplete: {
      type: String,
      validator(val) {
        process.env.NODE_ENV !== "production" &&
          console.warn(
            "[Element Warn][Select]'auto-complete' property will be deprecated in next major version. please use 'autocomplete' instead."
          );
        return true;
      },
    },
    size: String,
    disabled: Boolean,
    clearable: Boolean,
    filterable: Boolean,
    allowCreate: Boolean,
    loading: Boolean,
    popperClass: String,
    remote: Boolean,
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: Function,
    filterMethod: Function,
    multiple: Boolean,
    multipleLimit: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      required: false,
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    valueKey: {
      type: String,
      default: "value",
    },
    collapseTags: Boolean,
    popperAppendToBody: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createdLabel: null,
      createdSelected: false,
      inputed: this.multiple ? [] : {},
      tagdata: [],
      inputLength: 20,
      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: "",
      optionsCount: 0,
      filteredOptionsCount: 0,
      visible: false,
      softFocus: false,
      selectedLabel: "",
      hoverIndex: -1,
      query: "",
      previousQuery: null,
      currentPlaceholder: "",
      isOnComposition: false,
      isSilentBlur: false,
    };
  },
  watch: {
    propPlaceholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    },
    value: {
      handler: function(newVal, oldVal) {
        this.resetInputHeight();
        if (newVal) {
          this.tagdata = [];
          newVal.forEach((item) => {
            Object.getOwnPropertyNames(item).forEach((val, idx, array) => {
              if (val == this.label) {
                this.tagdata.push(item[val]);
              }
            });
          });
          this.inputed = newVal;
        }
      },
      deep: true, // 开启深度监听
    },

    visible(val) {
      if (val) {
        this.$refs.input.focus();
      } else {
        this.$refs.input.blur();
      }
    },
    softFocus(val) {
      this.visible = val;
    },
  },
  methods: {
    resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize() {
      this.resetInputWidth();
      if (this.multiple) this.resetInputHeight();
    },
    resetInputHeight() {
      if (this.collapseTags && !this.filterable) return;
      this.$nextTick(() => {
        if (!this.$refs.reference) return;
        let inputChildNodes = this.$refs.reference.$el.childNodes;
        let input = [].filter.call(
          inputChildNodes,
          (item) => item.tagName === "INPUT"
        )[0];
        const tags = this.$refs.tags;

        if (this.visible && this.emptyText !== false) {
        }
      });
    },
    handleFocus(event) {
      if (!this.softFocus) {
        if (this.filterable) {
          if (this.filterable && !this.visible) {
          }
          this.visible = true;
        }
        this.$emit("focus", event);
        this.softFocus = true;
      } else {
        this.softFocus = false;
      }
    },
    blur() {
      this.visible = false;
      this.$refs.reference.blur();
    },

    handleBlur(event) {
      setTimeout(() => {
        if (this.isSilentBlur) {
          this.isSilentBlur = false;
        } else {
          this.$emit("blur", event);
        }
      }, 50);
      this.softFocus = false;
    },
    getValueKey(item) {
      let key = "";
      Object.getOwnPropertyNames(item).forEach((val, idx, array) => {
        if (val == this.valueKey) {
          if (item[val].toLowerCase() !== "[object object]") {
            key = item[val];
          } else {
            key = getValueByPath(item.xm, this.valueKey);
          }
        }
      });
      return key;
    },
    //   点击清空按钮
    handleClearClick(event) {
      this.deleteSelected(event);
    },
    //   删除输入数据
    deleteSelected(event) {
      event.stopPropagation();
      const value = this.multiple ? [] : "";
      this.visible = false;
      this.$emit("clear");
    },
    //   删除标签
    deleteTag(event, tag) {
      let index = this.inputed.indexOf(tag);
      if (index > -1 && !this.selectDisabled) {
        const value = this.value.slice();
        value.splice(index, 1);
        this.$emit("remove-tag", tag.value);
      }
      event.stopPropagation();
    },
  },
  created() {},
  mounted() {
    this.handleResize();
    this.inputed = this.value;
  },
  beforeDestroy() {
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
.inputMultiple {
  display: inline-block;
  position: relative;
  line-height: 40px;
}
.inputMultiple__input {
  border: none;
  outline: none;
  padding: 0;
  margin-left: 15px;
  color: var(--el-select-multiple-input-color);
  font-size: var(--el-select-font-size);
  appearance: none;
  height: 28px;
  background-color: transparent;
}
::v-deep.is-focus .el-input__inner {
  border-color: #409eff;
}
.inputMultiple__tags {
  position: absolute;
  line-height: normal;
  white-space: normal;
  z-index: 1000;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .el-tag {
    box-sizing: border-box;
    border-color: transparent;
    margin: 2px 0 2px 6px;
    background-color: #f0f2f5;
  }
  .el-tag--info {
    --el-tag-background-color: #f4f4f5;
    --el-tag-border-color: #e9e9eb;
    --el-tag-font-color: #909399;
    --el-tag-hover-color: #909399;
  }
  .el-tag--small {
    padding: 0 8px;
    height: 24px;
    line-height: 22px;
  }
  .el-icon-close {
    background-color: var(--el-text-color-placeholder);
    right: -7px;
    top: 0;
    color: #fff;
  }
  .tag-group {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 90%;
  }
}
.inputMultiple__tags-text {
  text-overflow: ellipsis;
  display: inline-block;
  overflow-x: hidden;
  vertical-align: bottom;
}
</style>
